import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * /learn deep links always open inside the platform shell, so the left menu
 * stays visible instead of the learner landing on a stand-alone page.
 */
export const LearnRedirect = ({ target = 'home' }) => {
  const { courseId } = useParams();
  const query = new URLSearchParams({ module: 'pillars' });
  if (target === 'course' && courseId) query.set('course', courseId);
  return <Navigate to={`/platform?${query.toString()}`} replace />;
};

export default LearnRedirect;
